import logo from "./logo.svg";
import "./ObservationChart.css";
import horizontalGridlines from "../../../assets/images/horizontal_gridlines.svg";
import React , { useState,useRef,useLayoutEffect,useContext }from 'react';
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import IndexedDb from '../IndexedDb';
import ObservationPopup from './Popups/ObservationPopup'
import { format } from 'date-fns';
import moment from 'moment'
import Observationdata from '../../../data/Observationdata.json';
import {
  Box, Grid,
  Button, IconButton,
  TextField, Select, MenuItem,
  FormHelperText, FormControl, FormControlLabel,
  RadioGroup, Radio, Checkbox, GridList, GridListTile,
} from '@material-ui/core';
import { hr } from "date-fns/locale";
import { useStyles } from "../styles";
import { useSelector } from "react-redux";
import { pcrstate } from "../../../store/modules/PcrSlice";
import { throttle } from "lodash";
function App(props:any) {
  //Popup
  const classes = useStyles();
  const [obserpop, setobserpop] = React.useState(0);
  const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
  const pcrType = watch("pcr_type");
  const [formFields, setFormFields] = useState([
      {time: ''},
    ])
  const {
      fields: ObservationsFields,
      append: ObservationsAppend,
      remove: ObservationsRemove,
  } = useFieldArray({ control, name: "observations" });
  const[Indexdb,setIndexdb]=useState("");
  const[Item,setItem]=useState(0);
  const [uname, setname] = useState(" ");
  const [observationPopup, setObservationPopup] = React.useState(false);
  const [observationItemIndex, setObservationItemIndex] = React.useState<any>(null);
  const [observationItem, setObservationItem] = React.useState<any>(null);
  const [names, setNames] = useState([]);
  const [fr, setfr] = useState([]);
  const [Sat, setSat] = useState([]);
  const [Observationtime, setObservationtime] = useState([]);
  const [Observationtimechart, setObservationtimechart] = useState([]);
  setValue("chartData",false);
  let odbn:any=[];
  var valob = "";
  let resjson="";
  let valres:any=[];
  const[ResprateRedUpper , setResprateRedUpper] = useState<number>();
  const[ResprateYellowUpper , setResprateYellowUpper] = useState<number>();
  const[ResprateRedLower , setResprateRedLower] = useState<number>();
  const[ResprateYellowLower , setResprateYellowLower] = useState<number>();
  const[ResprateMax , setResprateMax] = useState<number>();
  const[FlowrateMax , setFlowrateMax] = useState<number>();
  const[SatMax , setSatMax] = useState<number>();
  const[BpMax , setBpMax] = useState<number>();
  const[BpdiaMax , setBpdiaMax] = useState<number>();
  const[HeartrateMax , setHeartrateMax] = useState<number>();
  const[TempMax , setTempMax] = useState<number>();
  const[ResprateMin , setResprateMin] = useState<number>();
  const[FlowrateMin , setFlowrateMin] = useState<number>();
  const[SatMin , setSatMin] = useState<number>();
  const[BpMin , setBpMin] = useState<number>();
  const[BpdiaMin , setBpdiaMin] = useState<number>();
  const[HeartrateMin , setHeartrateMin] = useState<number>();
  const[TempMin , setTempMin] = useState<number>();
  const[OSatRedUpper , setOSatRedUpper] = useState<number>();
  const[OSatYellowUpper , setOSatYellowUpper] = useState<number>();
  const[OSatRedLower , setOSatRedLower] = useState<number>();
  const[OSatYellowLower , setOSatYellowLower] = useState<number>();
  const[OFRedUpper , setOFRRedUpper] = useState<number>();
  const[OFRYellowUpper , setOFRYellowUpper] = useState<number>();
  const[OFRRedLower , setOFRRedLower] = useState<number>();
  const[OFRYellowLower , setOFRYellowLower] = useState<number>();
  const[BPRedUpper , setBPRedUpper] = useState<number>();
  const[BPYellowUpper , setBPYellowUpper] = useState<number>();
  const[BPRedLower , setBPRedLower] = useState<number>();
  const[BPYellowLower , setBPYellowLower] = useState<number>();
  const[BPdiaRedUpper , setBPdiaRedUpper] = useState<number>();
  const[BPdiaYellowUpper , setBPdiaYellowUpper] = useState<number>();
  const[BPdiaRedLower , setBPdiaRedLower] = useState<number>();
  const[BPdiaYellowLower , setBPdiaYellowLower] = useState<number>();
  const [textValue, setTextValue] = useState<string>("");
  const[HRRedUpper , setHRRedUpper] = useState<number>();
  const[HRYellowUpper , setHRYellowUpper] = useState<number>();
  const[HRRedLower , setHRRedLower] = useState<number>();
  const[HRYellowLower , setHRYellowLower] = useState<number>();
  const[TEMPRedUpper , setTEMPRedUpper] = useState<number>();
  const[TEMPYellowUpper , setTEMPYellowUpper] = useState<number>();
  const[TEMPRedLower , setTEMPRedLower] = useState<number>();
  const[TEMPYellowLower , setTEMPYellowLower] = useState<number>();
  const [bpsys, setbpsys] = useState([]);
  const [bpdia, setbpdia] = useState([]);
  const [heartrate, setheartrate] = useState([]);
  const [temp, settemp] = useState([]);
  const [conc, setconc] = useState([]);
  const [bloodsugar, setbloodsugar] = useState([]);
  const [PainScore, setPainScore] = useState([]);
  const[ResprateSteps , setResprateSteps] = useState<number>();
  const[FlowrateSteps , setFlowrateSteps] = useState<number>();
  const[SatSteps , setSatSteps] = useState<number>();
  const[BpSteps , setBpSteps] = useState<number>();
  const[BpdiaSteps , setBpdiaSteps] = useState<number>();
  const[HeartrateSteps , setHeartrateSteps] = useState<number>();
  const[TempSteps , setTempSteps] = useState<number>();
  const [RespiratoryRateMiddle1, setRespiratoryRateMiddle1] = useState(0);
  const [RespiratoryRateMiddle2, setRespiratoryRateMiddle2] = useState(0);
  const [OSaturationMiddle1, setOSaturationMiddle1] = useState(0);
  const [OSaturationMiddle2, setOSaturationMiddle2] = useState(0);
  const [OFlowRateMiddle1, setOFlowRateMiddle1] = useState(0);
  const [OFlowRateMiddle2, setOFlowRateMiddle2] = useState(0);
  const [BloodPressureMiddle1, setBloodPressureMiddle1] = useState(0);
  const [BloodPressureMiddle2, setBloodPressureMiddle2] = useState(0);
  const [HeartRateMiddle1, setHeartRateMiddle1] = useState(0);
  const [HeartRateMiddle2, setHeartRateMiddle2] = useState(0);
  const [TemperatureMiddle1, setTemperatureMiddle1] = useState(0);
  const [TemperatureMiddle2, setTemperatureMiddle2] = useState(0);
  const cardiacmonitored =getValues("cardiac_monitored");
  const [newborn, setnewborn] = useState(0);
  const [diastolic, setdiastolic] = useState(0);
  const [chartwidth, setchartwidth] = useState(0); 
  const [chartwidthcon, setchartwidthcon] = useState(0); 
  const [painscoreass, setpainscoreass] = useState(""); 
  const [Respchartheight, setRespchartheight] = useState(0); 
  const [Satchartheight, setSatchartheight] = useState(0); 
  const [FRchartheight, setFRchartheight] = useState(0); 
  const [Bpchartheight, setBpchartheight] = useState(0); 
  const [Bpdiachartheight, setBpdiachartheight] = useState(0); 
  const [Hrchartheight, setHrchartheight] = useState(0); 
  const [Tempchartheight, setTempchartheight] = useState(0); 
  const [Dob, setDob] = useState(false);
  const chartRef = React.useRef(null);
  const DOBs =getValues("DOB");
  const Obs =getValues("obstetric");
  const pcr = useSelector(pcrstate)
  //console.log(pcr);
  React.useEffect(() => {
    let db:any = null;
    db = localStorage.getItem("PatientDB");
    setIndexdb(db);
    handleobservationdata();
}, []) 
React.useLayoutEffect(() => {
  if(DOBs)
  {
   handleobservationdata();
  }
 },[DOBs])
 React.useEffect(() => {
  handleobservationdata();
 },[])
 React.useLayoutEffect(() => {
  handleobservationdata();
  },[Obs])
const handleobservationdata =async()=>{
  let dbs:any=null
 dbs= localStorage.getItem("PatientDB");
const indexedDb = new IndexedDb(dbs);      
await indexedDb.createObjectStore(indexedDb.patientcarerecord);
    let result = Observationdata;
    let lowvalueResprate;
    let highvalueResprate;
    let lowvaluesat;
    let highvaluesat;
    let lowvalueflowrate;
    let highvalueflowrate;
    let lowvalueheartrate;
    let highvalueheartrate;
    let lowvaluebp;
    let highvaluebp;
    let lowvaluetemp;
    let highvaluetemp;
    let  ResprateMax :any;
    let  FlowrateMax :any;
    let  SatMax   :any
    let  BpMax   :any
    let  BpdiaMax  :any
    let  HeartrateMax   :any
    let  TempMax   :any
    let  ResprateMin   :any;
    let  FlowrateMin  :any;
    let  SatMin   :any;
    let  BpMin  :any;
    let  BpdiaMin   :any;
    let  HeartrateMin   :any;
    let  TempMin  :any;
    let  ResprateSteps   :any;
    let  FlowrateSteps :any;
    let  SatSteps  :any;
    let  BpSteps   :any;
    let  BpdiaSteps   :any;
    let  HeartrateSteps :any;
    let  TempSteps   :any;

    if(result !=null)
    {
        var Maternity=null;
        let db:any = null;
        let observationdata = null ;
        let val:string="";
        let vBirthDate="";
        let Obstetric = 0;
        let Background =null;
        let Observation =null;
        var Obsetric=null;
        db = localStorage.getItem("PatientDB");
        localStorage.setItem("Diastolic","");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        val =  await indexedDb.getValues('Patientidentification','DOB');
        Obstetric = getValues("obstetric");    
        Background = await indexedDb.getAllValue('background');   
        }
        if(val && val!=null)
        {
             vBirthDate = val;
        
        var resbd=new Date(vBirthDate);
        const [day,month,year] = format(resbd, 'dd/MM/yyyy').split('/');
        const [Cday,Cmonth,Cyear] =format(new Date(), 'dd/MM/yyyy').split('/');
        var today =new Date();
        var dt = year+"-"+month+"-"+day;
        var bday=new Date(moment(dt).toDate());
        const age = today.getFullYear() - bday.getFullYear();
        const m = today.getMonth() - bday.getMonth();
        const d = today.getDate() - bday.getDate();
        if(d <=0 && m<=0 && age <= 0 && Obstetric !=1)
        {
            Maternity = Observationdata.Newborn;
            setnewborn(1);
        }
        else if(m<3 && age <= 0  && Obstetric !=1)
        {
            Maternity = Observationdata['1+ days'];
        }
        else if(m>=3 && age <= 0 && Obstetric !=1)
        {
            Maternity = Observationdata['3+ months'];
        }
        else if(age>=1&& age<5  && Obstetric !=1)
        {
            Maternity = Observationdata['1+ years'];
        }
        else if(age>=5&& age<12  && Obstetric !=1)
        {
            Maternity = Observationdata['5+ years'];
        }
        else if(age>=12&& age<18  && Obstetric !=1 )
        {
            Maternity = Observationdata['12+ years'];
        }
        else if(Obstetric ==1 )
        {
          Maternity = Observationdata.Maternity;     
          Obsetric = 1;        
        }
        else{
          Maternity = Observationdata['18+ years'];              
        }
        for(let i=0;i<Maternity.length;i++)
        {
           let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
           let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
           let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
           let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;
           if(Maternity[i].observation == "Respiratory Rate")
           {               
            setResprateRedUpper(upperred);
            setResprateYellowUpper(upperyellow);
            setResprateRedLower(lowerred);
            setResprateYellowLower(loweryellow);
            //lowvalueResprate =Number(Maternity[i].low_value);
           // highvalueResprate ==Number(Maternity[i].high_value);
            setResprateMax(Number(Maternity[i].high_value));
            setResprateMin(Number(Maternity[i].low_value));
            setResprateSteps(Number(Maternity[i].step));
            ResprateMax = Number(Maternity[i].high_value);
            ResprateMin = Number(Maternity[i].low_value)
            ResprateSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "O₂ Saturation")
           {
            let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
            let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
            let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
            let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;               
            setOSatRedUpper(upperred??0);
            setOSatYellowUpper(upperyellow);
            setOSatRedLower(lowerred??0);
            setOSatYellowLower(loweryellow);
           // lowvaluesat ==Number(Maternity[i].low_value);
           // highvaluesat ==Number(Maternity[i].high_value);
            setSatMax(Number(Maternity[i].high_value));
            setSatMin(Number(Maternity[i].low_value));
            setSatSteps(Number(Maternity[i].step));
            SatMax = Number(Maternity[i].high_value);
            SatMin = Number(Maternity[i].low_value)
            SatSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "O₂ Flow Rate")
           {
            let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
            let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
            let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
            let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;
            setOFRRedUpper(upperred);
            setOFRYellowUpper(upperyellow);
            setOFRRedLower(lowerred);
            setOFRYellowLower(loweryellow);
           // lowvalueflowrate ==Number(Maternity[i].low_value);
           // highvalueflowrate ==Number(Maternity[i].high_value);
            setFlowrateMax(Number(Maternity[i].high_value));
            setFlowrateMin(Number(Maternity[i].low_value));
            setFlowrateSteps(Number(Maternity[i].step));
            FlowrateMax = Number(Maternity[i].high_value);
            FlowrateMin = Number(Maternity[i].low_value)
            FlowrateSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "Systolic Blood Pressure"  || Maternity[i].observation =="Blood Pressure")
           {
            let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
            let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
            let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
            let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;
            setBPRedUpper(upperred);
            setBPYellowUpper(upperyellow);
            setBPRedLower(lowerred);
            setBPYellowLower(loweryellow);
           // lowvaluebp ==Number(Maternity[i].low_value);
          //  highvaluebp ==Number(Maternity[i].high_value);
            setBpMax(Number(Maternity[i].high_value!== undefined?Maternity[i].high_value:120 ));
            setBpMin(Number(Maternity[i].low_value!== undefined?Maternity[i].low_value:0));
            setBpSteps(Number(Maternity[i].step!== undefined?Maternity[i].step:20));
            BpMax = Number(Maternity[i].high_value);
            BpMin = Number(Maternity[i].low_value)
            BpSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "Diastolic Blood Pressure")
           {
            let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
            let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
            let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
            let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;
            setBPdiaRedUpper(upperred);
            setBPdiaYellowUpper(upperyellow);
            setBPdiaRedLower(lowerred);
            setBPdiaYellowLower(loweryellow);
           // lowvaluebp ==Number(Maternity[i].low_value);
           //  highvaluebp ==Number(Maternity[i].high_value);
            setBpdiaMax(Number(Maternity[i].high_value));
            setBpdiaMin(Number(Maternity[i].low_value));
            setBpdiaSteps(Number(Maternity[i].step));
            setdiastolic(1);
            localStorage.setItem("Diastolic","1");
            BpdiaMax = Number(Maternity[i].high_value);
            BpdiaMin = Number(Maternity[i].low_value)
            BpdiaSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "Heart Rate" || Maternity[i].observation =="Heart Rate (Apical)")
           {
            let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
            let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
            let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
            let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;
            setHRRedUpper(upperred);
            setHRYellowUpper(upperyellow);
            setHRRedLower(lowerred);
            setHRYellowLower(loweryellow);
           // lowvalueheartrate ==Number(Maternity[i].low_value);
          //  highvalueheartrate ==Number(Maternity[i].high_value);
            setHeartrateMax(Number(Maternity[i].high_value));
            setHeartrateMin(Number(Maternity[i].low_value));
            setHeartrateSteps(Number(Maternity[i].step));
            HeartrateMax = Number(Maternity[i].high_value);
            HeartrateMin = Number(Maternity[i].low_value)
            HeartrateSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "Temperature")
           {
            let upperred =Maternity[i].btf_ranges?.upper?.red_if_above;
            let upperyellow =Maternity[i].btf_ranges?.upper?.yellow_if_above;
            let lowerred =Maternity[i].btf_ranges?.lower?.red_if_below;
            let loweryellow =Maternity[i].btf_ranges?.lower?.yellow_if_below;
            setTEMPRedUpper(upperred);
            setTEMPYellowUpper(upperyellow);
            setTEMPRedLower(lowerred);
            setTEMPYellowLower(loweryellow);
          //  lowvaluetemp ==Number(Maternity[i].low_value);
          //  highvaluetemp ==Number(Maternity[i].high_value);
            setTempMax(Number(Maternity[i].high_value));
            setTempMin(Number(Maternity[i].low_value));
            setTempSteps(Number(Maternity[i].step));
            TempMax = Number(Maternity[i].high_value);
            TempMin = Number(Maternity[i].low_value)
            TempSteps = Number(Maternity[i].step)
           }
           if(Maternity[i].observation == "Consciousness")
           {
            let rows =Maternity[i].rows;
           
           }
        }
      }
      // if(Background !=null)
      // {
      //   for(let i=0;i<Background.length;i++)
      //   {
      //           if(Background[i].Key == "RespiratoryRateUpperRed")
      //           {
      //               setResprateRedUpper(Background[i].value.column);                                         
      //           }
      //           if(Background[i].Key == "RespiratoryRateUpperYellow")
      //           {
      //               setResprateYellowUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "RespiratoryRateMiddle1")
      //           {
      //               setRespiratoryRateMiddle1(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "RespiratoryRateMiddle2")
      //           {
      //               setRespiratoryRateMiddle2(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "RespiratoryRateLowerYellow")
      //           {
      //               setResprateYellowLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "RespiratoryRateLowerRed")
      //           {
      //               setResprateRedLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂SaturationUpperRed")
      //           {
      //               setOSatRedUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂SaturationUpperYellow")
      //           {
      //               setOSatYellowUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂SaturationMiddle1")
      //           {
      //               setOSaturationMiddle1(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂SaturationMiddle2")
      //           {
      //               setOSaturationMiddle2(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂SaturationLowerYellow")
      //           {
      //               setOSatYellowLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂SaturationLowerRed")
      //           {
      //               setOSatRedLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂FlowRateUpperRed")
      //           {
      //               setOFRRedUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂FlowRateUpperYellow")
      //           {
      //               setOFRYellowUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂FlowRateMiddle1")
      //           {
      //               setOFlowRateMiddle1(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂FlowRateMiddle2")
      //           {
      //               setOFlowRateMiddle2(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂FlowRateLowerYellow")
      //           {
      //               setOFRYellowLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "O₂FlowRateLowerRed")
      //           {
      //               setOFRRedLower(Background[i].value.column);
      //           }

      //           if(Background[i].Key == "BloodPressureUpperRed" && Obsetric === null)
      //           {
      //               setBPRedUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "BloodPressureUpperYellow" && Obsetric === null)
      //           {
      //               setBPYellowUpper(Background[i].value.column);
      //           }
      //           if( Background[i].Key == "BloodPressureMiddle1" && Obsetric === null)
      //           {
      //               setBloodPressureMiddle1(Background[i].value.column);
      //           }
      //           if( Background[i].Key == "BloodPressureMiddle2" && Obsetric === null)
      //           {
      //               setBloodPressureMiddle2(Background[i].value.column);
      //           }
      //           if( Background[i].Key == "BloodPressureLowerYellow" && Obsetric === null)
      //           {
      //               setBPYellowLower(Background[i].value.column);
      //           }
      //           if( Background[i].Key == "BloodPressureLowerRed" && Obsetric === null)
      //           {
      //               setBPRedLower(Background[i].value.column);
      //           }
                
      //           if(Background[i].Key == "SystolicBloodPressureUpperRed" && Obsetric === 1)
      //           {
      //               setBPRedUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "SystolicBloodPressureUpperYellow"&& Obsetric === 1)
      //           {
      //               setBPYellowUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "SystolicBloodPressureMiddle1"&& Obsetric === 1)
      //           {
      //               setBloodPressureMiddle1(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "SystolicBloodPressureMiddle2"&& Obsetric === 1)
      //           {
      //               setBloodPressureMiddle2(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "SystolicBloodPressureLowerYellow"&& Obsetric === 1)
      //           {
      //               setBPYellowLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "SystolicBloodPressureLowerRed"&& Obsetric === 1)
      //           {
      //               setBPRedLower(Background[i].value.column);
      //           }
                
      //           if(Background[i].Key == "HeartRateUpperRed")
      //           {
      //               setHRRedUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "HeartRateUpperYellow")
      //           {
      //               setHRYellowUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "HeartRateMiddle1")
      //           {
      //               setHeartRateMiddle1(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "HeartRateMiddle2")
      //           {
      //               setHeartRateMiddle2(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "HeartRateLowerYellow")
      //           {
      //               setHRYellowLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "HeartRateLowerRed")
      //           {
      //               setHRRedLower(Background[i].value.column);
      //           }

      //           if(Background[i].Key == "TemperatureUpperRed")
      //           {
      //               setTEMPRedUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "TemperatureUpperYellow")
      //           {
      //               setTEMPYellowUpper(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "TemperatureMiddle1")
      //           {
      //               setTemperatureMiddle1(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "TemperatureMiddle2")
      //           {
      //               setTemperatureMiddle2(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "TemperatureLowerYellow")
      //           {
      //               setTEMPYellowLower(Background[i].value.column);
      //           }
      //           if(Background[i].Key == "TemperatureLowerRed")
      //           {
      //               setTEMPRedLower(Background[i].value.column);
      //           }                              
      //   }
      // }
    }
    let db:any = null;
    let observationdata = null ;
    db = localStorage.getItem("PatientDB");
    if(db!=null && db !="")
    {
    const indexedDb = new IndexedDb(db);
    await indexedDb.createObjectStore(indexedDb.patientcarerecord);
    let val = await indexedDb.getAllValue('Observation'); 
    
    let resObservationsFields:any=[];
    for(let i=0;i<val.length;i++)
    {
        if(val[i].Key == "PatientWeight")
        {
            setname(val[i].value.column);
        }
        if(val[i].Key.includes("item"))
        {
            let res = val[i].value;
            resObservationsFields.push(res);
            setpainscoreass("")
            if(res.pa)
            {
              setpainscoreass(res.pa ==="1"?"* Patient reported pain score":"* Clinically Assessed Score")
            }
            
        }
    }
    resObservationsFields = resObservationsFields.sort((a:any,b:any)=>a.date.getTime()-b.date.getTime())
    ObservationsRemove();
    ObservationsAppend(resObservationsFields);
    let item =ObservationsFields.length;
    let resarr:any=[];
    //flowrate      
    for(let i=0;i<resObservationsFields.length;i++)
    {
        resarr.push((format(resObservationsFields[i].date,"HH:mm")));
    }
    // if(ObservationsFields.length < 18)
    // {
    // var Balanceli = (18 - resObservationsFields.length);
    // for(let i=0;i<Balanceli;i++)
    // {
    //   resarr.push('');
    // }
    // }    
    setObservationtime(resarr);
    resarr=[]
    for(let i=0;i<resObservationsFields.length;i++)
    {     
      if(resObservationsFields[i].resprate)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].resprate),
        });  
      }     
    }                    
    setNames(resarr);
    resarr=[]
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].sp)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].sp),
        });   
      }        
    }
    setSat(resarr)       
    resarr=[];
    //flowrate
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].fr)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].fr),
        });  
      }    
    }
    setfr(resarr);
    resarr=[];
    //Systolic bp
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].bpsys)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].bpsys),
        });
      }       
    }
    setbpsys(resarr);
    resarr=[];
    //Diastolic bp
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].bpdia)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].bpdia),
        });  
      }       
    }
    setbpdia(resarr);       
    resarr=[];
    //heartrate
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].heartrate)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].heartrate),
        });
      }       
    }
    //resarr.push(lowvalueheartrate,highvalueheartrate);
    setheartrate(resarr); 
    resarr=[];
    //Temperature
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].temp)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].temp),
        }); 
      }      
    }
    settemp(resarr);       
    resarr=[];
    //consciousness
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].conc)
      {
        if(resObservationsFields[i].conc)
        resarr.push({
          col: i,
          value: (resObservationsFields[i].conc),
        }); 
      }      
    }
    setconc(resarr);
    resarr=[];
    //Blood Suger
    for(let i=0;i<resObservationsFields.length;i++)
    {
      resarr.push(parseFloat(resObservationsFields[i].bgl));       
    }
    setbloodsugar(resarr);
    resarr=[];
    //Pain Score
    for(let i=0;i<resObservationsFields.length;i++)
    {
      if(resObservationsFields[i].ps)
      {
        resarr.push({
          col: i,
          value: parseInt(resObservationsFields[i].ps),
        }); 
      }          
    }
    setPainScore(resarr);
    }
    
  }
  const handleObservationPopup = (index: any, item: any): void => {
    setObservationItem(item);
    setObservationItemIndex(index);
    setObservationPopup(true);
   }
   const getWholeAndDecimal = (value:any) => {
    const [whole, decimal] = String(value).split('.');
    return Number(whole);
  }
  const getminnumber = (min:any,steps:any) =>{   
    if(min !== undefined && steps !== undefined)
    {
      var val = (Number(min)/Number(steps));
      var res = getWholeAndDecimal(val);
      var result = res * steps;
      return result;
    }
    else
    {
      return 0;
    }
  }
  const getmaxstteps = (max:any|undefined,steps:any|undefined)=>{
    if(max !== undefined && steps !== undefined)
    {       
      var Modval = (Number(max)%Number(steps));
      var Divval = (Number(max)/Number(steps));
      var Subval = (Number(steps)-Number(Modval));
      var Mulval = (getWholeAndDecimal(Number(Divval))*Number(steps));
      var res = (Number(Mulval)+Number(Modval)+Number(Subval));
      return res
    }
  }
  const getmaxsttepsInRange = (max:any|undefined,steps:any|undefined)=>{
    if(max !== undefined && steps !== undefined)
    {       
      var Modval = (Number(max)%Number(steps));    
      if(Number(Modval) > 0)
      {
        var res = (Number(Modval)+Number(max));
        return res
      }
      else
      {
        var res = (10+Number(max));
        return res
      }
      
    }
  }
  const getmaxstepsBp = (max:any|undefined,steps:any|undefined)=>{
    if(max !== undefined && steps !== undefined)
    {       
     if(Number(max) === 155)
     {
      return (Number(max)+10)
     }
     if(Number(max) === 135)
     {
      return (Number(max)+10)
     }
     else
     {
      return max;
     }
    }
  }
  const getmaxsttepresp = (max:any|0,steps:any|0,min:any|0)=>{
    if(max !== undefined && steps !== undefined)
    {    
      if(min === 15)
      {         
        var Modval = (Number(max)+Number(steps));  
        var res = (Number(max));
        return res  
      } 
      else
      {
        var Modval = (Number(max)+Number(steps));  
        var res = (Number(Modval)-5);
        return res  
      }  
    
    }
  }
  const getmaxsttephr = (max:any|undefined,steps:any|undefined)=>{
    if(max !== undefined && steps !== undefined)
    {    
      if(max === 220)
      {         
        var Modval = (Number(max)+Number(steps));  
        var res = (Number(max)+10);
        return res  
      } 
      else
      {
        return max
      }
    }
  }
  //
  const numDatapoints = ObservationsFields.length;
  const colWidthInPixels = 60;

  const headerCells:any= [];
  // for (var i = 1; i <= numDatapoints + 1; i++) {
  //   var cellContents = "";
  //   if (i <= numDatapoints) {
  //     cellContents = i.toString();
  //   } else {
  //    cellContents = "Add";               
  //   }   
  //   headerCells.push(
  //     <div className="headerCell" style={{ width: colWidthInPixels }}>
  //       {cellContents}
  //     </div:any
  //   );
  // }
  {ObservationsFields.map((item, index) => {
    var cellContents = item.date!==null && item.date !=="" ? format(item.date,"HH:mm") : "N/A" || "N/A";
    headerCells.push(
      <div className="headerCell" style={{ width: colWidthInPixels,cursor:"pointer" }} onClick={() => handleObservationPopup(index, item)}>
        {cellContents}
      </div>
    );
  })}
  headerCells.push(
    <div className="headerCell" style={{ width: colWidthInPixels,cursor:"pointer" }} onClick={() => handleObservationPopup(null, null)}>       
         Add      
    </div>
  );
  
  // sticky time header
  const handleChartScroll = () => {
    const obsCharts = document.getElementById("obsCharts") as HTMLElement;
    const observationsHeader = document.getElementById("observationsHeader") as HTMLElement;
    if(obsCharts && observationsHeader)
    {
      const scrollOffset = obsCharts.scrollLeft;
      observationsHeader.style.left = `-${scrollOffset}px`;
    }
  }
  React.useLayoutEffect(() => {
    const obsCharts = document.getElementById("obsCharts") as HTMLElement;
    if(obsCharts)
    {
      handleChartScroll();
      obsCharts.addEventListener("scroll", handleChartScroll);
      window.addEventListener("resize", handleChartScroll);
      return () => {
        obsCharts.removeEventListener("scroll", handleChartScroll);
        window.removeEventListener("resize", handleChartScroll);
      };
    }
  }, []);
  
  return (
    <div className="App">
      <ObservationPopup
        popState={observationPopup}
        setPopState={setObservationPopup}
        itemIndex={observationItemIndex}
        itemValue={observationItem}
        itemAppend={ObservationsAppend}
        itemRemove={ObservationsRemove}
        itemSetValue={setValue}
        items={obserpop}
        observationdata={handleobservationdata}
        observationdatas={props.handleobservationdata}
        setchartwidth={setchartwidth}
        chartwidth={chartwidth}
      />            
      <div style={{ padding: 44 }}>
        {/* <h1>Custom Chart Component</h1> */}
      </div>
      <div id="observationsHeaderContainer">
        <div
          id="observationsHeader"
          style={{
            //minWidth: (numDatapoints + 2) * colWidthInPixels,
            left: "0px",
          }}
        >
          {headerCells}
        </div>
      </div>
      <div id="obsCharts">
        <div id="observations" className="dataSection">
          <div>
            <Chart
              config={{
                observation: "Respiratory Rate",
                units: "Breaths per minute",
                low_value: names.filter((x:any) =>  !isNaN(x)).every((x) => x > Number(ResprateMin) )? (ResprateMin):getminnumber( Math.min(...names.filter((num) => !isNaN(num))as number[]),ResprateSteps),
                high_value:names.filter((x:any) =>  !isNaN(x)).every((x) => x <= Number(ResprateMax) )?getmaxsttepresp(ResprateMax,ResprateSteps,ResprateMin):getmaxstteps(Math.max(...names.filter((num) => !isNaN(num))as number[]),ResprateSteps),
                Red_high_value:(Number(getmaxsttepresp(ResprateMax,ResprateSteps,ResprateMin)) > Number(ResprateMax) ) ? (Number(getmaxsttepresp(ResprateMax,ResprateSteps,ResprateMin))) - (Number(ResprateMax)) : 0,
                step: ResprateSteps,
                btf_ranges: {
                  upper: {
                    red_if_above:pcr.RespiratoryRateUpperRed !== null && pcr.RespiratoryRateUpperRed !== undefined ? pcr.RespiratoryRateUpperRed: ResprateRedUpper,
                    yellow_if_above:pcr.RespiratoryRateUpperYellow !== null && pcr.RespiratoryRateUpperYellow !== undefined ? pcr.RespiratoryRateUpperYellow: ResprateYellowUpper,
                  },
                  lower: {
                    yellow_if_below:pcr.RespiratoryRateLowerYellow !== null && pcr.RespiratoryRateLowerYellow !== undefined ? pcr.RespiratoryRateLowerYellow: ResprateYellowLower,
                    red_if_below:pcr.RespiratoryRateLowerRed !== null && pcr.RespiratoryRateLowerRed !== undefined ? pcr.RespiratoryRateLowerRed: ResprateRedLower
                  },
                },
              }}
              data={names}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />
            <Chart
              config={{
                observation: " O2 Saturation ",
                units: "%",
                low_value: Sat.filter((x:any) =>  !isNaN(x)).every((x)=> x >  Number(SatMin)) ?(SatMin):(getminnumber(Math.min(...Sat.filter((num) => !isNaN(num))as number[]),SatSteps)),
                high_value: Sat.filter((x:any) =>  !isNaN(x)).every((x)=> x  <= Number(SatMax))?SatMax:getmaxstteps(Math.max(...Sat.filter((num) => !isNaN(num))as number[]),SatSteps),               
                step: SatSteps,
                btf_ranges: {
                  upper: {
                    red_if_above:pcr.O2SaturationUpperRed !== null && pcr.O2SaturationUpperRed !== undefined ? pcr.O2SaturationUpperRed: OSatRedUpper,
                    yellow_if_above: pcr.O2SaturationUpperYellow !== null && pcr.O2SaturationUpperYellow !== undefined ? pcr.O2SaturationUpperYellow:OSatYellowUpper,
                  },
                  lower: {
                    yellow_if_below:pcr.O2SaturationLowerYellow !== null && pcr.O2SaturationLowerYellow !== undefined ? pcr.O2SaturationLowerYellow: OSatYellowLower,
                    red_if_below:pcr.O2SaturationLowerRed !== null && pcr.O2SaturationLowerRed !== undefined ? pcr.O2SaturationLowerRed: OSatRedLower,
                  },
                },
              }}
              data={Sat}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />
             <Chart
              config={{
                observation: "O2 Flow Rate",
                units: "Litres per minute",
                low_value:  fr.filter((x:any) =>  !isNaN(x)).every((x) => x > Number(FlowrateMin)) ? FlowrateMin:getminnumber(Math.min(...fr.filter((num) => !isNaN(num))as number[]),FlowrateSteps),
                high_value: fr.filter((x:any) =>  !isNaN(x)).every((x) => x <= Number(FlowrateMax))?(FlowrateMax):getmaxstteps(Math.max(...fr.filter((num) => !isNaN(num))as number[]),FlowrateSteps),
                step: FlowrateSteps,
                btf_ranges: {
                  upper: {
                    red_if_above: pcr.O2FlowRateUpperRed !== null && pcr.O2FlowRateUpperRed !== undefined ? pcr.O2FlowRateUpperRed:OFRedUpper,
                    yellow_if_above:pcr.O2FlowRateUpperYellow !== null && pcr.O2FlowRateUpperYellow !== undefined ? pcr.O2FlowRateUpperYellow: OFRYellowUpper,
                  },
                  lower: {
                    yellow_if_below:pcr.O2FlowRateLowerYellow !== null && pcr.O2FlowRateLowerYellow !== undefined ? pcr.O2FlowRateLowerYellow: OFRYellowLower,
                    red_if_below:pcr.O2FlowRateLowerRed !== null && pcr.O2FlowRateLowerRed !== undefined ? pcr.O2FlowRateLowerRed: OFRRedLower
                  },
                },
              }}
              data={fr}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />
            {newborn == 0?    
             <Chart
              config={{
                observation: "Blood Pressure",
                units: "Systolic in mmHg",
                low_value: bpsys.filter((x:any) =>  !isNaN(x)).every((x) => x > Number(BpMin)) ?((BpMin)):(getminnumber(Math.min(...bpsys.filter((num) => !isNaN(num))as number[]),BpSteps)),
                high_value: bpsys.filter((x:any) =>  !isNaN(x)).every((x) => x <= Number(BpMax))?getmaxstepsBp(BpMax,BpSteps):getmaxstteps(Math.max(...bpsys.filter((num) => !isNaN(num))as number[]),BpSteps),
                Red_high_value:(Number(getmaxstepsBp(BpMax,BpSteps)) > Number(BpMax) ) ? (Number(getmaxstepsBp(BpMax,BpSteps))) - (Number(BpMax)) : 0,            
                step: BpSteps,
                btf_ranges: {
                  upper: {
                    red_if_above:pcr.SystolicBloodPressureUpperRed !== null && pcr.SystolicBloodPressureUpperRed !== undefined ? pcr.SystolicBloodPressureUpperRed: BPRedUpper,
                    yellow_if_above:pcr.SystolicBloodPressureUpperYellow !== null && pcr.SystolicBloodPressureUpperYellow !== undefined ? pcr.SystolicBloodPressureUpperYellow: BPYellowUpper,
                  },
                  lower: {
                    yellow_if_below:pcr.SystolicBloodPressureLowerYellow !== null && pcr.SystolicBloodPressureLowerYellow !== undefined ? pcr.SystolicBloodPressureLowerYellow: BPYellowLower,
                    red_if_below:pcr.SystolicBloodPressureLowerRed !== null && pcr.SystolicBloodPressureLowerRed !== undefined ? pcr.SystolicBloodPressureLowerRed: BPRedLower
                  },
                },
              }}
              data={bpsys}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />:null}
              {diastolic == 1 && newborn == 0?
             <Chart
              config={{
                observation: "Diastolic BP",
                units: "mmHg",
                low_value: bpdia.filter((x:any) =>  !isNaN(x)).every((x)=>x > Number(BpdiaMin)) ?(BpdiaMin):(getminnumber( Math.min(...bpdia.filter((num) => !isNaN(num))as number[]),BpdiaSteps)),
                high_value: bpdia.filter((x:any) =>  !isNaN(x)).every((x)=>x  <= Number(BpdiaMax))?getmaxsttepsInRange(BpdiaMax,BpdiaSteps):getmaxstteps(Math.max(...bpdia.filter((num) => !isNaN(num))as number[]),BpdiaSteps),
                Red_high_value:(Number(getmaxsttepsInRange(BpdiaMax,BpdiaSteps)) > Number(BpdiaMax) ) ? (Number(getmaxsttepsInRange(BpdiaMax,BpdiaSteps))) - (Number(BpdiaMax)) : 0,                           
                step: BpdiaSteps,
                btf_ranges: {
                  upper: {
                    red_if_above: BPdiaRedUpper,
                    yellow_if_above: BPdiaYellowUpper,
                  },
                  lower: {
                    yellow_if_below: BPdiaYellowLower,
                    red_if_below: BPdiaRedLower
                  },
                },
              }}
              data={bpdia}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />:null}
             <Chart
              config={{
                observation: "Heart Rate",
                units: "Beats per minute",
                low_value: heartrate.filter((x:any) =>  !isNaN(x)).every((x)=> x > Number(HeartrateMin)) ?(HeartrateMin):(getminnumber(Math.min(...heartrate.filter((num) => !isNaN(num))as number[]),HeartrateSteps)),
                high_value:  heartrate.filter((x:any) =>  !isNaN(x)).every((x)=> x <= Number(HeartrateMax))?(getmaxsttephr(HeartrateMax,HeartrateSteps)):getmaxstteps(Math.max(...heartrate.filter((num) => !isNaN(num))as number[]),HeartrateSteps),
                Red_high_value:(Number(getmaxsttephr(HeartrateMax,HeartrateSteps)) > Number(HeartrateMax) ) ? (Number(getmaxsttephr(HeartrateMax,HeartrateSteps))) - (Number(HeartrateMax)) : 0,                                      
                step: HeartrateSteps,
                btf_ranges: {
                  upper: {
                    red_if_above:pcr.HeartRateUpperRed !== null && pcr.HeartRateUpperRed !== undefined ? pcr.HeartRateUpperRed:HRRedUpper,
                    yellow_if_above:pcr.HeartRateUpperYellow !== null && pcr.HeartRateUpperYellow !== undefined ? pcr.HeartRateUpperYellow: HRYellowUpper,
                  },
                  lower: {
                    yellow_if_below:pcr.HeartRateLowerYellow !== null && pcr.HeartRateLowerYellow !== undefined ? pcr.HeartRateLowerYellow: HRYellowLower,
                    red_if_below:pcr.HeartRateLowerRed !== null && pcr.HeartRateLowerRed !== undefined ? pcr.HeartRateLowerRed: HRRedLower
                  },
                },
              }}
              data={heartrate}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />
            <Chart
              config={{
                observation: "Temperature",
                units: "°C",
                low_value: temp.filter((x:any) =>  !isNaN(x)).every((x) => x > Number(TempMin)) ? TempMin:getminnumber(Math.min(...temp.filter((num) => !isNaN(num))as number[]),TempSteps),
                high_value: temp.filter((x:any) =>  !isNaN(x)).every((x) => x <= Number(TempMax))?(TempMax):getmaxstteps(Math.max(...temp.filter((num) => !isNaN(num))as number[]),TempSteps),
                step: TempSteps,
                btf_ranges: {
                  upper: {
                    red_if_above:pcr.TemperatureUpperRed !== null && pcr.TemperatureUpperRed !== undefined ? pcr.TemperatureUpperRed: TEMPRedUpper,
                    yellow_if_above:pcr.TemperatureUpperYellow !== null && pcr.TemperatureUpperYellow !== undefined ? pcr.TemperatureUpperYellow: TEMPYellowUpper,
                  },
                  lower: {
                    yellow_if_below:pcr.TemperatureLowerYellow !== null && pcr.TemperatureLowerYellow !== undefined ? pcr.TemperatureLowerYellow: TEMPYellowLower,
                    red_if_below:pcr.TemperatureLowerRed !== null && pcr.TemperatureLowerRed !== undefined ? pcr.TemperatureLowerRed: TEMPRedLower
                  },
                },
              }}
              data={temp}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />
            <Chart
              config={{
                observation: "Consciousness",
                units: "AVPU",
                rows: [
                  {
                    label: "A",
                    colour: "white",
                  },
                  {
                    label: "V",
                    colour: "yellow",
                  },
                  {
                    label: "P",
                    colour: "red",
                  },
                  {
                    label: "U",
                    colour: "red",
                  },
                ],
              }}
              data={conc}
              // data={[
              //   {
              //     col: 0,
              //     value: "U",
              //   },
              //   {
              //     col: 1,
              //     value: "V",
              //   },
              //   {
              //     col: 2,
              //     value: "A",
              //   },
              //   {
              //     col: 3,
              //     value: "P",
              //   },
              //   {
              //     col: 4,
              //     value: "U",
              //   },
              //   {
              //     col: 5,
              //     value: "A",
              //   },
              //   {
              //     col: 6,
              //     value: "A",
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />     
            <div style={{marginBottom:"20px"}}></div>            
            <Chart
              config={{
                observation: "Pain*",
                units: "None (0) - Worst (10)",
                low_value: 0,
                high_value: 10,
                step: 2,              
                btf_ranges: {
                  upper: {
                    // red_if_above: ResprateRedUpper,
                     yellow_if_above: newborn == 1 ? 8 : null,
                  },
                  lower: {
                     //yellow_if_below: newborn == 1 ? 10 : null,
                    // red_if_below: ResprateRedLower,
                  },
                },               
              }}
              data={PainScore}
              // data={[
              //   {
              //     col: 0,
              //     value: 20,
              //   },
              //   {
              //     col: 2,
              //     value: 28,
              //   },
              //   {
              //     col: 3,
              //     value: 14,
              //   },
              //   {
              //     col: 5,
              //     value: 18,
              //   },
              // ]}
              numDatapoints={numDatapoints}
              colWidth={colWidthInPixels}
            />
            <div className={"obsChartArea"} style={{ marginBottom: "20px" }}>
              <div className={"header"}>
                <div className={"title"}>Blood Glucose Level</div>
                <div className={"units"}>mmol /L</div>
              </div>
              <div className={"body"}>
                <div className={"labels"}>
                  <div className={"label"}>&nbsp;</div>
                </div>
                <div className={"obsChart"} style={{
                  display: "flex",
                  height: 25,
                  alignItems: "center",
                  minWidth: ((numDatapoints * colWidthInPixels) + colWidthInPixels),
                }}>
                  {bloodsugar.map((item, index) => (
                  <div key={index} style={{
                    height: "25px",
                    width: colWidthInPixels,
                    border: "1px solid #00142e",
                    borderLeft: 0,
                    textAlign: "center",
                    overflow: "hidden",
                    boxSizing: "border-box",
                  }}>
                    {(item >= 0) ? item : <span style={{color:"white"}}>0</span>}
                  </div>
                  ))}
                  
                  <div style={{
                    height: "25px",
                    width: `calc(100% - ${(numDatapoints * colWidthInPixels)}px`,
                    background: "rgba(240, 240, 240, 0.5)",
                    borderBottom: "1px solid #aaa",
                    borderTop: "1px solid #aaa",
                    boxSizing: "border-box",
                  }}>
                    <div style={{
                      height: "100%",
                      width: `${colWidthInPixels}px`,
                      background: "#FFFFFF",
                    }} />
                  </div>
                </div>
              </div>
            </div>
            {painscoreass && (
            <div className={"obsChartArea"} style={{ marginBottom: "20px" }}>
              <div className={"header"}>
                <div className={""} style={{
                  marginTop: "10px",
                  marginLeft: "-10px",
                  whiteSpace: "nowrap",
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#00122A",
                }}>
                  {painscoreass}
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// function Chart(props:any) {
//   // Setup
//   const config = props.config;
//   const data = props.data;
//   const rowHeightInPixels = 25;
//   const colWidthInPixels = props.colWidth;
//   const chartWidthInPixels = props.numDatapoints * colWidthInPixels;
//   const Red_high_value = props.config.Red_high_value;
//   if (config.rows) {
//     // Setup for fixed chart (chart rows are defined in configuration)

//     var chartHeightInPixels = config.rows.length * rowHeightInPixels;

//     // Create labels
//     var labels = config.rows.map((row:any) => (
//       <div
//         className="label"
//         style={{
//           height: rowHeightInPixels,
//         }}
//       >
//         {row.label}
//       </div>
//     ));

//     // Crete row backgrounds representing BTF ranges
//     var BTFRanges = config.rows.map((row:any, index:any) => {
//       return (
//         <div
//           className={["rowBackground", row.colour].join(" ")}
//           style={{
//             height: rowHeightInPixels,
//             width: chartWidthInPixels + colWidthInPixels,
//             top: index * rowHeightInPixels,
//           }}
//         />
//       );
//     });
//   } else {
//     // Setup for variable chart (chart rows defined by data)

//     // Get y range of data
//     const datapoints = data.map((datapoint:any) => datapoint.value);
//     const highestDatapoint = Math.max(...datapoints);
//     const lowestDatapoint = Math.min(...datapoints);

//     // Determine bounds of suitable y axis
//     var yMax:any = Math.max(
//       config.high_value,
//       Math.ceil(highestDatapoint / config.step) * config.step
//     );
//     var yMin:any = Math.min(
//       config.low_value,
//       Math.floor(lowestDatapoint / config.step) * config.step
//     );
//     var chartRange = yMax - yMin;
//     var chartColorAdj = yMax - Red_high_value;
//     var chartHeightInPixels = (rowHeightInPixels * chartRange) / config.step;

//     // Create labels
//     var labels:any = [];
//     for (var i = yMax; i >= yMin; i -= config.step) {
//       labels.push(
//         <div
//           className="label"
//           style={{
//             height: rowHeightInPixels,
//             position: "relative",
//             top: 0 - rowHeightInPixels / 2,
//           }}
//         >
//           {i}
//         </div>
//       );
//     }

//     // Crete BTF range backgrounds
//     var BTFRanges:any = [];
//     ["upper", "lower"].forEach((direction) => {
//       ["blue", "yellow", "red"].forEach((color) => {
//         const threshold =
//           config.btf_ranges[direction][
//             color + (direction == "upper" ? "_if_above" : "_if_below")
//           ];
//         if (threshold) {
//           BTFRanges.push(
//             <BTFRange
//               height={
//                 direction == "upper"
//                   ? ((chartHeightInPixels) - (getYPos(threshold))) 
//                   : (getYPos(threshold))
//               }
//               width={chartWidthInPixels + colWidthInPixels}
//               direction={direction == "upper" ? "up" : "down"}
//               color={color}
//             />          
//           );
//           if(direction == "upper" && Red_high_value > 0)
//           {
//             BTFRanges.push(
//               <BTFRange
//                 height={Red_high_value + "px"}
//                 width={chartWidthInPixels + colWidthInPixels}
//                 direction={direction == "upper" ? "up" : "down"}
//                 color="white"
//               />  
//               );  
//           }
//         }
//       });
//     });

//   }
//   // Create horizontal gridlines
//   const horizontalGridlines = []
//   for (let i = 0; i < chartHeightInPixels; i += rowHeightInPixels) {
//     horizontalGridlines.push(<div className="horizontalGridline" key={i} style={{ height: rowHeightInPixels, top: i }} />);
//   }
//   // Create vertical gridlines
//   const verticalGridlines = [];
//   for (let i = 0; i <= props.numDatapoints; i++) {
//     verticalGridlines.push(
//       <div
//         className="verticalGridline"
//         key={i}
//         style={{ width: colWidthInPixels }}
//       />
//     );
//   }

//   // Create dots
//   const dots = data.map((datapoint:any) => {
//     return (
//       <div
//         className="dot"
//         style={{
//           left: colWidthInPixels / 2 + datapoint.col * colWidthInPixels,
//           bottom: getYPos(datapoint.value),
//         }}
//         key={datapoint.col}
//       />
//     );
//   });

//   // Create connecting lines
//   const lines = data.map((datapoint:any, index:any) => {
//     const nextDatapoint = data[index + 1];
//     if (!nextDatapoint) {
//       return "";
//     }
//     return (
//       <line
//         id={"line_" + datapoint.col}
//         data-name={"line_" + datapoint.col}
//         x1={colWidthInPixels / 2 + datapoint.col * colWidthInPixels}
//         y1={chartHeightInPixels - getYPos(datapoint.value)}
//         x2={colWidthInPixels / 2 + nextDatapoint.col * colWidthInPixels}
//         y2={chartHeightInPixels - getYPos(nextDatapoint.value)}
//         fill="none"
//         stroke="#00142e"
//         stroke-width="3"
//       />
//     );
//   });

//   // Function to return the Y position (in pixels) for a given datapoint.
//   // Logic varies depending on whether chart is fixed or variable
//   function getYPos(datapoint:any) {
//     // Logic for variable chart
//     if (!config.rows) {
//       return ((datapoint - yMin) / chartRange) * chartHeightInPixels;
//     }

//     // Logic for fixed chart
//     var YPos = 0;
//     config.rows.forEach((row:any, index:any) => {
//       if (row.label == datapoint) {
//         index = 3- index ;
//         YPos = index * rowHeightInPixels + rowHeightInPixels / 2;
//       }
//     });
//     return YPos;
//   }

//   // Render
//   return (
//     <div className="obsChartArea">
//       <div className="header">
//         <div className="title">{config.observation}</div>
//         <div className="units">{config.units}</div>
//       </div>
//       <div className="body">
//         <div className="labels">{labels}</div>
//         <div
//           className="obsChart"
//           style={{
//             height: rowHeightInPixels * ((yMax- yMin) / config.step),
//             minWidth: chartWidthInPixels + colWidthInPixels,
//           }}
//         >
//           {BTFRanges}
//           <div
//             className="horizontalGridlines"
//             style={{
//               backgroundImage: `url(${horizontalGridlines})`,
//               backgroundSize: `${rowHeightInPixels}px, ${rowHeightInPixels}px`,
//             }}
//           />
//           <div className="verticalGridlines">{verticalGridlines}</div>
//           <div
//             className="emptyMask"
//             style={{
//               left: chartWidthInPixels + colWidthInPixels,
//             }}
//           />
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             preserveAspectRatio="none"
//             viewBox={`0 0 ${chartWidthInPixels} ${chartHeightInPixels}`}
//             height={chartHeightInPixels}
//             width={chartWidthInPixels}
//             className="line"
//           >
//             {lines}
//           </svg>
//           {dots}
//         </div>
//       </div>
//     </div>
//   );
// }
function Chart(props:any) {
  // Setup
  const config = props.config
  const data = props.data
  const rowHeightInPixels = 25
  const colWidthInPixels = props.colWidth
  const chartWidthInPixels = props.numDatapoints * colWidthInPixels
  const Red_high_value = props.config.Red_high_value;
  const getWholeAndDecimal = (value:any) => {
    const [whole, decimal] = String(value).split('.');
    return Number(whole);
  }
  const getminnumber = (min:any,steps:any) =>{   
    if(min !== undefined && steps !== undefined)
    {
      var val = (Number(min)/Number(steps));
      var res = getWholeAndDecimal(val);
      var result = res * steps;
      return result;
    }
    else
    {
      return 0;
    }
  }
  const getmaxstteps = (max:any|undefined,steps:any|undefined)=>{
    if(max !== undefined && steps !== undefined)
    {       
      var Modval = (Number(max)%Number(steps));
      var Divval = (Number(max)/Number(steps));
      var Subval = (Number(steps)-Number(Modval));
      var Mulval = (getWholeAndDecimal(Number(Divval))*Number(steps));
      var res = (Number(Mulval)+Number(Modval)+Number(Subval));
      return res
    }
  }
  if (config.rows) {

    // Setup for fixed chart (chart rows are defined in configuration)

    var chartHeightInPixels = config.rows.length * rowHeightInPixels

    // Create labels
    var labels = config.rows.map((row:any) => <div 
                      className="label"
                      style={{
                        height: rowHeightInPixels,
                      }}
                  >{row.label}</div>)

    // Crete row backgrounds representing BTF ranges
    var BTFRanges = config.rows.map((row:any, index:any) => {
      return <div 
        className={[
          "rowBackground", 
          row.colour
        ].join(' ')} 
        style={{ 
          height: rowHeightInPixels, 
          width: chartWidthInPixels + colWidthInPixels, 
          top: index * rowHeightInPixels 
        }} />
    })

  } else {

    // Setup for variable chart (chart rows defined by data)

    // Get y range of data
    const datapoints = data.map((datapoint:any) => datapoint.value)
    const highestDatapoint = Math.max(...datapoints)
    const lowestDatapoint = Math.min(...datapoints)

    // Determine bounds of suitable y axis
    
    var yMax:any = Math.max(config.high_value, Math.ceil(highestDatapoint / config.step) * config.step)
    var yMin:any = Math.min(config.low_value, Math.floor(lowestDatapoint / config.step) * config.step)
    //var yMin:any =data.filter((x:any) =>  !isNaN(x)).every((x:any) => x > Number(config.low_value)) ? config.low_value:getminnumber(Math.min(...data.filter((num:any) => !isNaN(num))as number[]),config.step)
    //var yMax:any =data.filter((x:any) =>  !isNaN(x)).every((x:any) => x <= Number(config.high_value))?(config.high_value):getmaxstteps(Math.max(...data.filter((num:any) => !isNaN(num))as number[]),config.step)
    var chartRange = yMax - yMin
    var chartHeightInPixels = rowHeightInPixels * chartRange / config.step

    // Create labels
    var labels:any = []
    for (var i = yMax; i >= yMin; i -= config.step) {
      labels.push(<div 
                      className="label"
                      style={{
                        height: rowHeightInPixels,
                        position: "relative",
                        top: 0 - rowHeightInPixels / 2
                      }}
                  >{i}</div>);
    }

    // Crete BTF range backgrounds
    var BTFRanges:any = [];
    ["upper", "lower"].forEach(direction => {
      ["blue", "yellow", "red"].forEach(color => {
        const threshold = config.btf_ranges[direction][color + (direction == "upper" ? "_if_above" : "_if_below")]
        if (threshold) {
          BTFRanges.push(
            <BTFRange 
              height={direction == "upper" ? chartHeightInPixels - getYPos(threshold) : getYPos(threshold)} 
              width={chartWidthInPixels + colWidthInPixels} 
              direction={direction == "upper" ? "up" : "down"} 
              color={color} 
            />
          )
          if(direction == "upper" && Red_high_value > 0)
          {
            BTFRanges.push(
              <BTFRange
                height={Red_high_value + "px"}
                width={chartWidthInPixels + colWidthInPixels}
                direction={direction == "upper" ? "up" : "down"}
                color="white"
              />  
              );  
          }
        }
      })
    })

  } 

  // Create horizontal gridlines
  const horizontalGridlines = []
  for (let i = 0; i < chartHeightInPixels; i += rowHeightInPixels) {
    horizontalGridlines.push(<div className="horizontalGridline" key={i} style={{ height: rowHeightInPixels, top: i }} />);
  }

  // Create vertical gridlines
  const verticalGridlines = []
  for (let i = 0; i <= props.numDatapoints; i++) {
    verticalGridlines.push(<div className="verticalGridline" key={i} style={{ width: colWidthInPixels }} />);
  }

  // Create dots
  const dots = data.map((datapoint:any) => {
    return (
      <div 
        className="dot" 
        style={{
          left: colWidthInPixels / 2 + datapoint.col * colWidthInPixels,
          bottom: getYPos(datapoint.value)
        }} 
        key={datapoint.col}
      />
    )
  })

  // Create connecting lines
  const lines = data.map((datapoint:any, index:any) => {
    const nextDatapoint = data[index+1]
    if (!nextDatapoint) { return "" }
    return <line 
          id={"line_" + datapoint.col}
          data-name={"line_" + datapoint.col}
          x1={colWidthInPixels / 2 + datapoint.col * colWidthInPixels}
          y1={chartHeightInPixels - getYPos(datapoint.value)}
          x2={colWidthInPixels / 2 + nextDatapoint.col * colWidthInPixels}
          y2={chartHeightInPixels - getYPos(nextDatapoint.value)}
          fill="none" 
          stroke="#00142e" 
          stroke-width="3"
        />
  })

  // Function to return the Y position (in pixels) for a given datapoint.
  // Logic varies depending on whether chart is fixed or variable
  function getYPos(datapoint:any) {
    
    // Logic for variable chart
    if (!config.rows) {
      return (datapoint - yMin) / chartRange * chartHeightInPixels
    }

    // Logic for fixed chart
    var YPos = 0
    config.rows.forEach((row:any, index:any) => {
      if (row.label == datapoint) {
        index = 3- index ;
        YPos = index * rowHeightInPixels + rowHeightInPixels / 2
      }
    })
    return YPos
    
  }
  // Render
  return (
    <div className="obsChartArea">
      <div className="header">
        <div className="title">{config.observation}</div>
        <div className="units">{config.units}</div>
      </div>
      <div className="body">
        <div className="labels">{labels}</div>
        <div className="obsChart" style={{ 
            height: rowHeightInPixels * ((yMax - yMin) / config.step), 
            minWidth: chartWidthInPixels + colWidthInPixels 
          }}>
          {BTFRanges}
          <div 
            className="horizontalGridlines">
              {horizontalGridlines}
            </div>
          <div className="verticalGridlines">{verticalGridlines}</div>
          <div 
            className="emptyMask" 
            style={{ 
              left: chartWidthInPixels + colWidthInPixels 
            }}
          />
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            preserveAspectRatio="none"
            viewBox={`0 0 ${chartWidthInPixels} ${chartHeightInPixels}`} 
            height={chartHeightInPixels}
            width={chartWidthInPixels}
            className="line"
          >
            {lines}
          </svg>
          {dots}
        </div>
      </div>
    </div>
  )

}


function BTFRange(props:any) {
  return (
    <div
      className={["btfRange", props.color, props.direction].join(" ")}
      style={{
        height: props.height ? props.height : 0,
        width: props.width,
      }}
    />
  );
}

export default App;
